var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[(_vm.erros.length > 0)?_c('ul',{staticClass:"erro"},_vm._l((_vm.erros),function(erro,index){return _c('li',{key:index,domProps:{"innerHTML":_vm._s(erro)}})}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }